module.exports = __webpack_public_path__ + "img/totem-info.ca845a44.png";